import { FC, Fragment } from "preact/compat";
import { Transition } from "@headlessui/react";
import { Outlet } from "react-router-dom";
import { useApp } from "~/core/store";
import { ErrorBoundary } from "~/components";
import { useBreakpoint } from "~/hooks";
import ShareScreen from "./ShareScreen";
import cn from "classnames";

const Content: FC = () => {
    const {
        dialog: { issueTracker, isBackdrop, isSwipePanel },
        mobile: {
            isDropdownOpen,
            isMenuOpen,
            isMenuPage,
            isTrackerOpen,
            isTrackerPage,
            dropdownStyle,
            closeBackdrop,
        },
    } = useApp();
    const bpMd = useBreakpoint("md");
    const isMobileBackdrop =
        isTrackerOpen.value || isMenuOpen.value || isDropdownOpen.value;
    const isAriaHidden =
        issueTracker.show.value ||
        isMenuPage.value ||
        isTrackerPage.value ||
        isMobileBackdrop ||
        isBackdrop.value ||
        isSwipePanel.value;

    return (
        <>
            {!bpMd.value && (
                <Transition
                    as={Fragment}
                    show={isMobileBackdrop}
                    enter="transform transition duration-200 ease-in"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="transform transition duration-100 ease-out"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div
                        onClick={() => closeBackdrop()}
                        className={cn(
                            "fixed inset-0 z-[60] backdrop-blur select-none",
                            dropdownStyle.value === "dark"
                                ? "bg-black/50"
                                : "bg-white/20",
                        )}
                    />
                </Transition>
            )}
            <div
                data-content=""
                aria-hidden={isAriaHidden ? "true" : "false"}
                inert={isAriaHidden}
                className="w-full bg-white"
            >
                <ErrorBoundary>
                    <Outlet />
                </ErrorBoundary>
                <ShareScreen />
            </div>
        </>
    );
};

export default Content;
